/** @jsx jsx */
import { jsx } from "@emotion/core"
import PropTypes from "prop-types"
import { Input as ANTInput } from "antd"
import { EditFilled } from "@ant-design/icons"
import {
  inputStyles,
  inputContainerStyles,
  loading,
  tickIcon,
  editIcon,
  tickImg,
} from "./styles"
import loader from "../../assets/images/loader.svg"
import tick from "../../assets/images/icon-tick-2.svg"

/**
- Standard Input component for accepting textual user input.
- Based on top of Antd [Input](https://ant.design/components/input/), This component accepts all of antd input props and more.
**/
export const Input = (props) => {
  const { error, ...rest } = props

  return (
    <div css={inputContainerStyles} className="atom-input-container">
      <ANTInput {...rest} css={inputStyles(error)} />
      {typeof error === "string" && <span className="error-text">{error}</span>}
    </div>
  )
}
const suffixIcon = (icon, onIconClick) => {
  if (icon === "saved") {
    return (
      <div css={tickIcon} onClick={onIconClick}>
        <img src={tick} alt="saved" css={tickImg} />
      </div>
    )
  } else if (icon === "typing") {
    return <img src={loader} alt="loader" css={loading} />
  } else if (icon === "none") {
    return ""
  }
  return <EditFilled css={editIcon} onClick={onIconClick} />
}

export const InputWithIcon = (props) => {
  const { error, icon, onIconClick, ...rest } = props

  return (
    <div css={inputContainerStyles} className="atom-input-container">
      <ANTInput {...rest} ref={props.parentref} css={inputStyles(error)} />
      {!error && suffixIcon(icon, onIconClick)}
      {error && <span className="error-text">{error}</span>}
    </div>
  )
}

Input.propTypes = {
  /** Apart from all standard input [props](https://ant.design/components/input/), this component accepts -  */
  /** error string, only to be passed if input is in error state. */
  error: PropTypes.string,
}

Input.defaultProps = {
  error: "",
}

InputWithIcon.propTypes = {
  /** The type of the icon */
  icon: PropTypes.oneOf(["none", "edit", "saved", "typing"]),
  /** Gets called when the user clicks on the icon */
  onIconClick: PropTypes.func,
  /** error string, only to be passed if input is in error state. */
  error: PropTypes.string,
}

InputWithIcon.defaultProps = {
  icon: "edit",
  error: "",
  parentref: null,
}
